import {Card, Flag, type FlagProps} from 'platform/components';
import {HStack, Show, Text, VStack} from 'platform/foundation';

import {EMPTY_PLACEHOLDER, type Nullish, type RequiredTestIdProps, suffixTestId} from 'shared/web';

interface AbcXyzClassCardProps extends RequiredTestIdProps {
  title: string;
  classLetter: string | Nullish;
  name?: string | Nullish;
  hint?: string | Nullish;
  colorScheme: FlagProps['colorScheme'];
}

export function AbcXyzClassCard(props: AbcXyzClassCardProps) {
  return (
    <Card isFullHeight data-testid={props['data-testid']}>
      <VStack spacing={1}>
        <Text size="xSmall" color="secondary">
          {props.title}
        </Text>
        <HStack spacing={3} align="center">
          <Flag
            colorScheme={props.colorScheme}
            label={props.classLetter ?? EMPTY_PLACEHOLDER}
            data-testid={suffixTestId('class', props)}
          />
          <VStack spacing={0}>
            <Show when={props.name}>
              {(name) => (
                <Text size="small" alternative data-testid={suffixTestId('name', props)}>
                  {name}
                </Text>
              )}
            </Show>
            <Show when={props.hint}>
              {(hint) => (
                <Text size="xSmall" color="secondary" data-testid={suffixTestId('hint', props)}>
                  {hint}
                </Text>
              )}
            </Show>
          </VStack>
        </HStack>
      </VStack>
    </Card>
  );
}
